import LinkCard from './LinkCard';
import { Card, Flex, Skeleton } from '@blockanalitica/ui';
import { ReactNode } from 'react';

export default function AsyncLinkCard({
  title,
  error,
  isLoading,
  children,
  to,
  hoverBorderColor
}: {
  title: ReactNode;
  error: Error | boolean | undefined;
  isLoading: boolean;
  children: ReactNode;
  to: string;
  hoverBorderColor?: string;
}) {
  if (isLoading) {
    return (
      <Card variant="linkCard" flex="1">
        <Flex alignItems="center" gap="2xs" padding="s">
          <Skeleton height="1" width="100%" />
        </Flex>
        <Card variant="linkCardInset" gap="s" justifyContent="space-between">
          <Skeleton height="344px" width="100%" />
        </Card>
      </Card>
    );
  }
  if (error) {
    return null;
  }

  return (
    <LinkCard
      to={to}
      variant="linkCard"
      flex="1"
      hoverBorderColor={hoverBorderColor}>
      <Flex alignItems="center" gap="2xs" padding="s">
        {title}
      </Flex>
      <Card variant="linkCardInset" gap="s" justifyContent="space-between">
        {children}
      </Card>
    </LinkCard>
  );
}
